import { ConfigProvider } from "antd";
import { Locale } from "antd/lib/locale-provider";
import en_GB from "antd/lib/locale/en_GB";
import fr_FR from "antd/lib/locale/fr_FR";
import i18n from "config/i18n/i18n";
import { routers } from "config/routes";
import dayjs from "dayjs";
import dayjsBusinessDays from "dayjs-business-days2";
import relativeTime from "dayjs/plugin/relativeTime";
import updateLocale from "dayjs/plugin/updateLocale";
import utc from "dayjs/plugin/utc";
import { I18nextProvider } from "react-i18next";
import "react-phone-input-2/lib/style.css";
import { RouterProvider } from "react-router-dom";

// Order matters: neonumy-ui's :root vars (gold palette) must load before
// styles.less, whose :root override (blue palette) needs to win the cascade.
import "@neonumy/neonumy-ui/lib/index.css";
import "./resources/styles/styles.less";

const CONFIG_TRANSLATIONS: Record<string, Locale> = {
  fr: fr_FR,
  en: en_GB,
};

dayjs.extend(dayjsBusinessDays);
dayjs.extend(updateLocale);
dayjs.extend(relativeTime);
dayjs.extend(utc);

export default function App() {
  return (
    <I18nextProvider i18n={i18n}>
      <ConfigProvider locale={CONFIG_TRANSLATIONS[i18n.language]}>
        <RouterProvider router={routers} />
      </ConfigProvider>
    </I18nextProvider>
  );
}
